<!--
 * @Author: DYM
 * @Date: 2020-07-10 11:55:59
 * @LastEditors: DQL
 * @LastEditTime: 2021-05-20 15:38:39
 * @Description: 菜单排序
-->
<template>
  <div
    class="l-page l-page--detail"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        class="c-page__header-title"
      >
        菜单排序
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <el-button
          type="primary"
          icon="kestrel-icon ki-save"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button
          icon="kestrel-icon ki-repeat"
          @click="handleReset"
        >
          重置
        </el-button>
        <el-button
          icon="kestrel-icon ki-close"
          @click="handleClose"
        >
          关闭
        </el-button>
      </div>
    </div>
    <!-- 页面头部 End -->

    <!-- 页面主内容：详情 Start -->
    <div
      class="l-page__body l-page--detail__body"
    >
      <hm-page-card
        class="c-card--detail"
      >
        <div
          class="u-text-danger u-mg-tb-6"
        >
          注意：层级超过5的菜单将不会在系统左侧导航菜单中显示
        </div>
        <el-tree
          ref="menuTree"
          class="o-tree-overflow--unset"
          node-key="nodeCode"
          default-expand-all
          draggable
          :data="treeData"
          :props="defaultProps"
          :expand-on-click-node="false"
          :allow-drop="handleAllowDrop"
          @node-drop="handleNodeDrop"
        />
      </hm-page-card>
    </div>
    <!-- 页面主内容：详情 End -->
  </div>
</template>

<script>
import { getMenuTree, menuSort } from './menu.service.js';
import _ from 'lodash';

export default {
  name: 'MenuSort',
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      /* 树组件配置 Start */
      treeData: [], // 树组件数据
      // 树组件默认配置
      defaultProps: {
        children: 'childNodes',
        label: 'nodeName'
      },
      /* 树组件配置 End */

      isExceedLevel: false, // 判断是否已有节点超出层级

      menuSortList: [], // 保存提交的菜单数据

      initMenuTree: [], // 存储修改前的菜单，用于重置

      hasSort: false // 判断是否进行了排序
    };
  },
  methods: {
    /**
     * @description: 获取系统菜单树
     * @return {*}
     */
    getSystemMenuTree () {
      const _this = this;
      _this.$emit('update:isLoading', true);
      getMenuTree()
        .then(rsp => {
          // 菜单树赋值
          _this.treeData = rsp.data.childNodes;
          // 存储修改前的菜单数据
          _this.initMenuTree = JSON.parse(JSON.stringify(_this.treeData));
        })
        .catch(err => {
          console.err('获取系统菜单树失败！', err);
        })
        .finally(() => {
          _this.$emit('update:isLoading', false);
        });
    },
    /**
     * @description: 保存
     * @return {*}
     */
    handleSave () {
      const _this = this;

      // 清空提交菜单数据
      _this.menuSortList = [];
      // 初始化菜单层级判定状态
      _this.isExceedLevel = false;

      // 根结点的parentNodeCode为-1
      _this.dataFormat(_this.treeData, -1, 1, []);

      // 数据格式化完成后进行保存操作
      _this.$nextTick(() => {
        console.log('menuSortList', _this.menuSortList);
        if (!_this.isExceedLevel) {
          _this.$emit('update:isLoading', true);

          menuSort(_this.menuSortList)
            .then(rsp => {
              _this.$alert('保存成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              // 重置状态
              _this.hasSort = false;
              _this.getSystemMenuTree();
              _this.$emit('callback', '');
              // _this.$emit('handleClose', false);
            })
            .catch(err => {
              _this.$emit('update:isLoading', false);
              console.error('菜单排序保存错误！', err);
            });
        }
      });
    },
    /**
     * @description:
     * @param {*}
     * @return {*}
     */
    handleReset () {
      if (this.hasSort) {
        this.$confirm('是否确认重置菜单顺序的调整？', '确认', {
          type: 'warning'
        }).then(() => {
          this.treeData = JSON.parse(JSON.stringify(this.initMenuTree));
          this.hasSort = false;
        });
      }
    },
    /**
     * @description: 取消
     * @return {*}
     */
    handleClose () {
      if (this.hasSort) {
        this.$confirm('菜单排序信息为保存，是否确认离开？', '确认', {
          type: 'warning'
        }).then(() => {
          this.$emit('handleClose', false);
        });
      } else {
        this.$emit('handleClose', false);
      }
    },
    /**
     * @description: 拖拽时判定目标节点能否被放置
     * @param {Object} draggingNode,拖拽的节点
     * @param {Object} dropNode,放置的节点
     * @param {String} type,放置的位置{'prev','inner' ,'next'},分别表示放置在目标节点前、插入至目标节点和放置在目标节点后
     * @return {*} true/false,判定该节点能否被放置
     */
    handleAllowDrop (draggingNode, dropNode, type) {
      // 如果目标节点为菜单，则不能放置在里面
      if (dropNode.data.menuType === '1') {
        return type !== 'inner';
      } else {
        return true;
      }
    },
    /**
     * @description: 格式化提交数据
     * @param {Array} _data，循环的数组
     * @param {Array} parentNodeCode,设置父节点
     * @param {Number} level,菜单层级
     * @param {String} parentTreePath,菜单路径
     * @return {*}
     */
    dataFormat (_data, parentNodeCode, level, parentTreePath) {
      // 如果层级超过5级，弹出错误提示
      if (level > 5) {
        this.isExceedLevel = true;
        const _treePath = _.join(parentTreePath, '->');
        this.$alert(`【${_treePath}】下的菜单层级超过5级！`, '提示', {
          confirmButtonText: '确定',
          type: 'error',
          callback: action => {
          }
        });
        return;
      }
      // 遍历树数据, 用for...of...便于跳出循环
      for (const [index, item] of _data.entries()) {
        // 如果已经判定有层级超过5层，跳出循环
        // 因递归判断层级大于5时,return 只跳出当前循环，不会跳出所有循环
        if (this.isExceedLevel) {
          return;
        }
        // 拷贝节点信息
        const _nodeData = JSON.parse(JSON.stringify(item));
        // 设置根结点的parentNodeCode, 设置plsx
        _nodeData.parentNodeCode = parentNodeCode;
        _nodeData.plsx = index;
        // 删除子节点
        delete (_nodeData.childNodes);
        // 记录节点的路径，用于层级超过5层时的错误提示
        item.treePath = _.concat(parentTreePath, item.nodeName);
        // 将节点信息存储到提交数组
        this.menuSortList.push(_nodeData);
        // 如果节点的子节点长度大于0，再次遍历
        if (item.childNodes && item.childNodes.length > 0) {
          this.dataFormat(item.childNodes, item.nodeCode, level + 1, item.treePath);
        }
      }
    },
    /**
     * @description:
     * @param {*} draggingNode
     * @param {*} dropNode
     * @param {*} dropType
     * @param {*} ev
     * @return {*}
     */
    handleNodeDrop (draggingNode, dropNode, dropType, ev) {
      this.hasSort = true;
    }
  },
  created () {
    this.getSystemMenuTree();
  }
};
</script>
